'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z' });

var ConfirmationNumber = function ConfirmationNumber(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ConfirmationNumber = (0, _pure2.default)(ConfirmationNumber);
ConfirmationNumber.muiName = 'SvgIcon';

exports.default = ConfirmationNumber;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ConfirmationNumber.js
// module id = 2273
// module chunks = 0